import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Sun } from "lucide-react";
import { api, formatApiError } from "../lib/api";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";

export default function AdminLogin() {
  const navigate = useNavigate();
  const [form, setForm] = useState({ email: "", password: "" });
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await api.post("/auth/login", form);
      navigate("/admin");
    } catch (err) {
      setError(formatApiError(err, "Login failed. Please try again."));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div data-testid="admin-login-page" className="min-h-screen flex items-center justify-center px-6 bg-muted/40">
      <div className="w-full max-w-md bg-white border border-border rounded-md p-8 sm:p-10 fade-up">
        <div className="flex items-center gap-2 mb-8">
          <span className="w-9 h-9 rounded-md bg-primary flex items-center justify-center">
            <Sun className="w-5 h-5 text-white" />
          </span>
          <span className="font-heading font-bold">Jehovah Nissi <span className="text-primary">Solar Agency</span></span>
        </div>
        <h1 className="font-heading text-2xl sm:text-3xl font-semibold tracking-tight">Admin Login</h1>
        <p className="text-sm text-muted-foreground mt-1 mb-8">Sign in to manage orders.</p>
        <form data-testid="admin-login-form" onSubmit={submit} className="space-y-5">
          <div className="space-y-2">
            <Label htmlFor="email">Email</Label>
            <Input id="email" data-testid="admin-email-input" type="email" required value={form.email} onChange={(e) => setForm((f) => ({ ...f, email: e.target.value }))} placeholder="admin@jnsolar.com" className="focus:ring-2 focus:ring-primary" />
          </div>
          <div className="space-y-2">
            <Label htmlFor="password">Password</Label>
            <Input id="password" data-testid="admin-password-input" type="password" required value={form.password} onChange={(e) => setForm((f) => ({ ...f, password: e.target.value }))} placeholder="Your password" className="focus:ring-2 focus:ring-primary" />
          </div>
          {error && <p data-testid="admin-login-error" className="text-sm text-destructive">{error}</p>}
          <Button data-testid="admin-login-submit" type="submit" disabled={loading} className="w-full rounded-full bg-primary hover:bg-primary/90 text-white h-11 active:scale-[0.98] transition-[background-color,transform] duration-200">
            {loading ? "Signing in..." : "Sign In"}
          </Button>
        </form>
        <Link to="/" data-testid="back-to-store-link" className="block text-center text-sm text-muted-foreground hover:text-primary transition-colors duration-200 mt-6">
          Back to store
        </Link>
      </div>
    </div>
  );
}
